import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, inject } from '@angular/core';
import { AuthService as RealAuthService } from '../../../../../../api/services/auth.service';

@Component({
  selector: 'app-ai-chat-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ai-chat-header.component.html',
  styleUrl: './ai-chat-header.component.css',
})
export class AiChatHeaderComponent implements OnInit {
  private readonly realAuth = inject(RealAuthService);

  @Input() isExpanded = false;
  @Input() hasConversation = false;
  @Input() activeAgentName = 'Security Assistant';
  @Input() activeAgentColor = '#8B5CF6';

  profile: { name?: string; email?: string; avatarUrl?: string } | null = null;

  ngOnInit(): void {
    const token = localStorage.getItem('accessToken');
    this.realAuth.getProfile(token).subscribe({
      next: (data) => { this.profile = data.data; },
      error: () => {},
    });
  }

  get initials(): string {
    const name = this.profile?.name ?? '';
    return name.trim().split(/\s+/).map((w: string) => w[0]).join('').toUpperCase().slice(0, 2) || '?';
  }

  get firstName(): string {
    return this.profile?.name?.split(' ')[0] || 'there';
  }

  get greeting(): string {
    const h = new Date().getHours();
    if (h < 12) return `Good morning, ${this.firstName}`;
    if (h < 17) return `Good afternoon, ${this.firstName}`;
    return `Good evening, ${this.firstName}`;
  }

  logout(): void {
    this.closeMenu();
    const token = localStorage.getItem('accessToken');
    this.realAuth.logout(token).subscribe({ error: () => {} });
    localStorage.clear();
    window.location.href = '/login';
  }

  @Output() collapseRequested = new EventEmitter<void>();
  @Output() expandRequested = new EventEmitter<void>();
  @Output() newPromptRequested = new EventEmitter<void>();
  @Output() historyRequested = new EventEmitter<void>();
  @Output() settingsRequested = new EventEmitter<void>();

  menuOpen = false;

  toggleMenu(event?: Event): void {
    event?.stopPropagation();
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  triggerMenuAction(action: 'new' | 'history' | 'settings'): void {
    this.closeMenu();
    if (action === 'new') { this.newPromptRequested.emit(); return; }
    if (action === 'history') { this.historyRequested.emit(); return; }
    this.settingsRequested.emit();
  }

  @HostListener('document:keydown.escape')
  handleEscape(): void {
    this.closeMenu();
  }
}
